import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BannerWrapper, BannerText, BannerButtons, BtnAceptar, BtnEsenciales } from './CookieBanner.styles';

const COOKIE_KEY = 'cookieConsent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(COOKIE_KEY));

  if (!visible) return null;

  const accept = (value) => {
    localStorage.setItem(COOKIE_KEY, value);
    setVisible(false);
  };

  return (
    <BannerWrapper>
      <BannerText>
        Usamos cookies propias y de terceros (Google AdSense) para mejorar tu experiencia y mostrarte publicidad relevante.
        Puedes aceptar todas o usar solo las esenciales.{' '}
        <Link to="/legal/privacidad">Política de privacidad</Link>
        {' · '}
        <Link to="/legal/cookies">Política de cookies</Link>
      </BannerText>
      <BannerButtons>
        <BtnEsenciales onClick={() => accept('essential')}>Solo esenciales</BtnEsenciales>
        <BtnAceptar onClick={() => accept('all')}>Aceptar todas</BtnAceptar>
      </BannerButtons>
    </BannerWrapper>
  );
}
